import { render } from "./Fete.vue?vue&type=template&id=cda59c2a"
import script from "./Fete.vue?vue&type=script&lang=js"
export * from "./Fete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__